import React from "react";
import {ReactComponent as PlaneRight} from 'assets/img/planeRight.svg';
import styles from './PlaneLine.module.scss'
import {Divider} from '@material-ui/core';
import {getHoursAndMinutes} from 'data/utils/calculators';

export interface IPlaneLineProps {
  timeOfTakeOff: number;
  timeOfLanding: number;
}


const PlaneLine = ({timeOfTakeOff, timeOfLanding}: IPlaneLineProps) => {
  return (
    <div className={styles.planeLine}>
      <Divider
        className={styles.locationLine}
      />
      <PlaneRight
        className={`${styles.planeIcon} ${styles.flip}`}
      />
      <small
        className={styles.hours}
      >Duration {getHoursAndMinutes(timeOfTakeOff, timeOfLanding)}</small>
    </div>
  )
};

PlaneLine.defaultProps = {
  timeOfTakeOff: 0,
  timeOfLanding: new Date().getTime(),
};

export default PlaneLine;
